import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders ,HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class RaisedTicketService {

  private apiUrl = 'http://your-api-url/tickets';

  constructor(private http: HttpClient) {}

  addTicket(request:any,file:any): Observable<any> {
    console.log(request)
    console.log(file)

    const formData = new FormData();
    formData.append("attachment", file)
    //formData.append("userParams",JSON.stringify(bulkUserData), { type: 'text/plain' );
    formData.append('data', JSON.stringify(request));
   let headers = new HttpHeaders();

    let header = headers.append('Authorization', 'Bearer-'+'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InZpc2hlc2hAbGludXhtYW50cmEuY29tIiwiY3VycmVudEVudGl0eSI6eyJpZCI6IjY2N2MwYTczYjQ0OTM4YmNjMWNmMmQ0YSIsImVudGl0eUNvZGUiOiJHSUxQSU4ifSwiY3VycmVudFByb2plY3QiOnsiaWQiOiI2NjdjMGU5ZTM5NTVmMDBhYWVhMWI2MWMiLCJwcm9qZWN0Q29kZSI6IlBSQUdZQU4ifSwiaWF0IjoxNzE5NDczNzQ2LCJleHAiOjE3MTk1MDk3NDZ9.VOhM4II-nGplDyCQhskf7Ow_k2IWLcvDpPTo6ftzbs4');;
   
    let httpParam : HttpParams=new HttpParams();
  
    return this.http.post("https://tippi.linuxmantra.com/api/tickets",formData,{observe:"response"})}

  getTickets(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }}
